import styled from "styled-components";

const MenuItem = styled.div`
  margin: 1rem 3rem 1rem 1rem;
  font-size: 16px;
  color: white;
  background-color: transparent;
  border: none;
  box-shadow: none;

  &:hover {
    text-underline: white;
  }
`;

export default MenuItem;
